import { USER_LOCALE } from '../actions/types';
import { ROMANIAN_LOCALE } from '../../languages';

const initialState = {
  ...( ROMANIAN_LOCALE )
};

const reducer = function(state = initialState, action) {
  switch (action.type) {
    case USER_LOCALE:
      return {
        ...state,
        lang: action.payload.lang,
        messages: action.payload.messages,
      };
    default:
      return state;
  }
};

export default reducer;
